module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZUAAAABAQMAAAAsFaGZAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAAyM/VgACT7QAAAAJ0Uk5TAP9bkSK1AAAAEElEQVR4nGP4Ycff/IA0AgDAYBuJ/d9tXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/dashed-border.png
// module id = 744
// module chunks = 0